import Vue from 'vue';
import popper from './popper';

Vue.directive('popper', popper);
